import React, { useMemo, useCallback } from 'react';
import MirsTable from 'components/general/table/Table.js';
import { useViewport } from 'components/general/useViewPort'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { DressageGroupColumns } from '../events/dressage/Columns';
import NotAvailable from 'components/common/NotAvailable';
import { isStartListStatus, isFinishedStatus, isLiveStatus } from 'helpers/status';
import CaptionTable from 'components/general/table/CaptionTable';
import Status from 'components/presentation/Status';
import LoaderSubComponent from 'components/general/LoaderSubComponent';
import TableExpanded from '../events/dressage/TableExpandedGP';
import {TableExpanded as TableEspandedFS} from '../events/dressage/TableExpandedFS';
import { isDressageGranPrixFreestyle } from '../helper/EquHelpers';


function EquDressageIndividual({ data, hideCaption }) {
  const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters()

  const { breakPoint } = useViewport();
  const isMobile = breakPoint === "sm" || breakPoint === "xs" 
  
  const resultStatus = data?.results?.status?.code;
  const scheduleStatus = data?.results?.schedule?.status?.code;

  const isStartList = isStartListStatus(resultStatus);
  const isFinished = isFinishedStatus(resultStatus);
  const isLive = isLiveStatus(resultStatus)
  const isFreeStyle = isDressageGranPrixFreestyle(mirs_rsc)

  const tableColumns = useMemo(() => DressageGroupColumns(), []);

  const renderRowSubComponent = useCallback(({ row }) => {
    let componentExpanded = isFreeStyle ? <TableEspandedFS row={row?.original} /> : <TableExpanded row={row?.original} officials={data?.results?.officials}/>
    return (
      <LoaderSubComponent component={componentExpanded} />
    )
    // eslint-disable-next-line
  }, [resultStatus]);

 
  if (!data?.results?.items) return <NotAvailable />;

  const currentId = data?.results?.extendedInfos?.find(ei => ei?.ei_code === 'CURRENT')?.ei_value; 

  const getHiddenColumns = () => {
    const finishedHidden = isFinished ? ['StartOrder', 'StartTime'] : [];
    const startListHidden = isStartList ? ['Rank', 'QualMark', 'Expander'] : [];
    const mobileHidden = isMobile ? ['StartOrder', 'StartTime', 'Name', 'Horse'] : ['AthleteHorse'];
    const qualMarkHidden = isFreeStyle ?  ['QualMark'] : [] ;
    return [...finishedHidden, ...startListHidden, ...mobileHidden, ...qualMarkHidden];
  }

  const getCurrentIndicator = (row) => {
    const isCurrent =  row.original.participant.code === currentId;
    let out = {className: isCurrent ? 'currentIndicator' : ''}
    return out  
  }

  const getInitialSortBy = () => {
    return isStartList ? [{ id: 'StartOrder', desc: false }] : [{ id: 'Rank', desc: false }];
  }


  const caption = (
    <CaptionTable
      rightCol={
          <>
              <div className="d-flex">
                  <Status typeToPrint="result" scheduleStatus={scheduleStatus} resultStatus={resultStatus} />
              </div>
          </>
        }
     />
  )

  return (
    <>
      <MirsTable
        id={`mirs-table-results-${mirs_rsc}`}
        data={data?.results?.items}
        columns={tableColumns}
        keyRow={"participant-code"}
        initialSortBy={getInitialSortBy()}
        hiddenColumns={getHiddenColumns()}
        renderRowSubComponent={renderRowSubComponent}
        getRowProps={row => { return getCurrentIndicator(row) }}
        caption={hideCaption ? undefined: caption}
      />
    </>
  );
}

export default EquDressageIndividual;
